"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toWords = void 0;
// treść jednostek
var UNITS = [
    'zero',
    'jeden',
    'dwa',
    'trzy',
    'cztery',
    'pięć',
    'sześć',
    'siedem',
    'osiem',
    'dziewięć',
    'dziesięć',
    'jedenaście',
    'dwanaście',
    'trzynaście',
    'czternaście',
    'piętnaście',
    'szesnaście',
    'siedemnaście',
    'osiemnaście',
    'dziewiętnaście'
];
// Tablica opisów dziesiątek
var TENS = [
    'dwadzieścia',
    'trzydzieści',
    'czterdzieści',
    'pięćdziesiąt',
    'sześćdziesiąt',
    'siedemdziesiąt',
    'osiemdziesiąt',
    'dziewięćdziesiąt'
];
// Tablica obisów setek
var HUNDREDS = [
    '',
    'sto',
    'dwieście',
    'trzysta',
    'czterysta',
    'pięćset',
    'sześćset',
    'siedemset',
    'osiemset',
    'dziewięćset'
];
// Dwuwymiarowa tablica tysięcy,milionów,miliarów ...
var ORTHER_UNITS = [
    ['tysiąc', 'tysiące', 'tysięcy'],
    ['milion', 'miliony', 'milionów'],
    ['miliard', 'miliardy', 'miliardów'],
    ['bilion', 'biliony', 'bilionów'],
    ['biliard', 'biliardy', 'biliardów'],
    ['trylion', 'tryliony', 'trylionów'],
    ['tryliard', 'tryliardy', 'tryliardów'],
    ['kwadrylion', 'kwadryliony', 'kwadrylionów'],
    ['kwadryliard', 'kwadryliardy', 'kwadryliardów']
];
/**
 * Konwersja małych liczb na tekst ()
 *
 * @param {number} value liczba
 * @returns {(string | null)} liczba tekstowo
 */
function smallValueToWords(value) {
    if (value === 0) {
        return null;
    }
    var valueInWords = '';
    // Konwertuj setki.
    var hundreds = Math.floor(value / 100);
    if (hundreds > 0) {
        valueInWords += HUNDREDS[hundreds];
        value -= hundreds * 100;
    }
    // Konwertuj dziesiątki i jedności.
    if (value > 0) {
        if (valueInWords.length > 0) {
            valueInWords += ' ';
        }
        if (value < 20) {
            //  Liczby poniżej 20 przekonwertuj na podstawie
            //  tablicy jedności.
            valueInWords += UNITS[value];
        }
        else {
            //  Większe liczby przekonwertuj łącząc nazwy
            //  krotności dziesiątek z nazwami jedności.
            valueInWords += TENS[Math.floor(value / 10) - 2];
            var lastDigit = value % 10;
            if (lastDigit > 0) {
                valueInWords += ' ';
                valueInWords += UNITS[lastDigit];
            }
        }
    }
    return valueInWords;
}
/**
 * Obliczenia dla dużych liczb ... i odmiana prawidłowa ich wartości..
 * 2 - D. lm (tysięcy)
 * 1 - M. lm (tysiące)
 * 0 - M. lp (tysiąc)
 *
 * @param {number} value liczba do zamiany
 * @returns {number} indeks w tablicy odmian
 */
function getBigUnitIndex(value) {
    var lastDigit = value % 10;
    if (value / 10 >= 1 && lastDigit === 1) {
        return 2;
    }
    var last2digits = value % 100;
    if ((last2digits >= 10 && (last2digits <= 20 || lastDigit === 0)) || lastDigit > 4) {
        return 2;
    }
    return lastDigit === 1 ? 0 : 1;
}
/**
 * wewnętrzna funkcja rekurencyjna zamienijąca liczbę na tekst
 *
 * @param {RefString} valueInWords odwołanie do tekstu który jest tworzony przez funkcję
 * @param {number} value liczba do zamiany
 * @param {number} level która potęga liczby tysiąc jest obsługiwan przez funkcję 0- 0-1000, 1- 1001-1000000 itp
 * @returns {number} liczba która pozostała do zamiany na tekst
 */
function _towordsinternal(valueInWords, value, level) {
    var smallValue = 0;
    var divisor = Math.pow(1000, level + 1);
    var rest = value;
    if (divisor <= value) {
        //  Jeśli liczbę da się podzielić przez najbliższą
        //  potęgę 1000, kontynuuj rekurencję.
        value = _towordsinternal(valueInWords, value, level + 1);
        var pvalue = value / divisor;
        smallValue = Math.floor(pvalue);
        if (valueInWords.text.length > 0) {
            valueInWords.text += ' ';
        }
        rest = value - smallValue * divisor;
        if (smallValue > 0) {
            // teraz dopisuje jeden, np: jeden tysiąc
            if (smallValue > 1 || valueInWords.text.length > 0 || rest === 0) {
                valueInWords.text += smallValueToWords(smallValue);
                valueInWords.text += ' ';
            }
        }
        if (smallValue > 0) {
            var ulevel = ORTHER_UNITS[level];
            if (ulevel !== undefined) {
                var bindex = getBigUnitIndex(smallValue);
                valueInWords.text += ulevel[bindex];
            }
        }
    }
    return rest;
}
/**
 * zamiana liczby całkowitej na tekst
 *
 * @param {number} value liczba całkowita
 * @returns {string} liczba słownie
 */
function _towords(value) {
    if (value === 0) {
        // Zero.
        return UNITS[0];
    }
    var valueInWords = {
        text: ''
    };
    var smallValue = _towordsinternal(valueInWords, value, 0);
    if (smallValue > 0) {
        if (valueInWords.text.length > 0) {
            valueInWords.text += ' ';
        }
        valueInWords.text += smallValueToWords(smallValue);
    }
    return valueInWords.text;
}
/**
 * Zamiana liczny na słownie
 *
 * @export
 * @param {number} value liczba do zamiany na słownie
 * @returns {string} liczba słownie
 */
function toWords(value) {
    // Generalna funkcja ptzetworzenia zmiennej
    if (value < 0) {
        value = value * -1;
    }
    return _towords(Math.floor(value));
}
exports.toWords = toWords;
exports.default = toWords;
//# sourceMappingURL=toWords.js.map